import { render, staticRenderFns } from "./WidgetCallbackNotes.vue?vue&type=template&id=0c0ab375&scoped=true"
import script from "./WidgetCallbackNotes.vue?vue&type=script&lang=js"
export * from "./WidgetCallbackNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0ab375",
  null
  
)

export default component.exports